/**
 * 銷貨單是否已有任一有效庫存配置（輕量防呆；不驗 qty 加總）。
 */

import {
  getSalesOrderAllocationStockId,
  getSalesOrderLineInvAllocations,
} from '#/modules/crmMgmt/salesOrder/helper/salesOrderFieldAccessors';

export function hasSalesOrderInventoryAllocation(detail) {
  const lines = detail?.lines ?? [];

  return lines.some((line) => {
    const allocations = getSalesOrderLineInvAllocations(line);
    return allocations.some(
      (allocation) => getSalesOrderAllocationStockId(allocation) && Number(allocation.qty) > 0,
    );
  });
}
